import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { State } from "../../store";
import "./style/finalizeWithLoginStyle.scss";
import "../../../style/alerts.scss";
import "../../../style/buttons.scss";
import "../../../style/feature.scss";
import InvoiceButtons from "./InvoiceButtons";
import { SubmitHandler, useForm } from "react-hook-form";
import { InputsFinalize } from "./FinalizeNoLogin";
import FormInput from "../../../utils/FormInput";
import BasketSummary from "./BasketSummary";
import { FormElementModel } from "../../models/FormElementModel";
import { invoiceForm } from "./inputsForm/InputPayFormModels";
import useMyAccount from "../MyAccount/hooks/useMyAccount";
import EcardButton from "./ecardPayment/EcardButton";
import EcardSummary from "./ecardPayment/EcardSummary";
import useFinalizeManager from "./hooks/useFinalizeManager";
import LoadingSpinner from "../../../features/Loading/LoadingSpinner";
import { PaymentLogos } from "../../../features/PaymentLogo";
import { useTranslation } from "react-i18next";
import ReactPixel from "react-facebook-pixel";
import useFacility from "../../../utils/hooks/useFacility";
import RecipientAndPurchaserForm from "./RecipientAndPurchaserForm";
import { gaEvent } from "../../models/ga";
import { post } from "../../api";
import { ADD_TO_BASKET_URL, REMOVE_ITEM_BASKET_URL } from "../../api/apiRoutes";
import Timer from "./Timer";
import EAButton from "../shared/Buttons/EAButton";
import ConsentInputs from "./ConsentInputs/ConsentInputs";

interface IProps {
  onPayTransaction: (value: InputsFinalize) => void;
  onSaveReservation: (value: InputsFinalize) => void;
  alertPayment: string;
  total: number;
  paymentUrl: string;
  loader: boolean;
}

const FinalizeWithLogin: React.FC<IProps> = ({
  onPayTransaction,
  onSaveReservation,
  alertPayment,
  total,
  paymentUrl,
  loader,
}: IProps) => {
  const userData = useSelector((state: State) => state.auth.userData);
  const [invoiceType, setInvoiceType] = useState<
    "noInvoice" | "customerInvoice" | "companyInvoice" | "recipientAndPurchaserInvoice"
  >("noInvoice");
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const { t } = useTranslation();
  const { eCardPaymnet, alert } = useFinalizeManager();
  const [email, setEmail] = useState<string>();
  const facilityIds = useFacility();

  useMyAccount();

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    reset,
    setValue,
  } = useForm<InputsFinalize>({
    defaultValues: userData,
  });

  const handleRefreshBasket = async () => {
    //FAKOWE DODAWANIE I USUWANIE KOSZKA TYLKO ABY WYELIMINOWAC BLAD Index: 0 Size: 0
    const { result } = await post(ADD_TO_BASKET_URL, { facilityIds: `0,${facilityIds}` });
    await post(REMOVE_ITEM_BASKET_URL, { idx: result.length - 1 });
  };

  useEffect(() => {
    reset(userData);
    //eslint-disable-next-line
  }, [userData]);

  useEffect(() => {
    handleRefreshBasket();
    //eslint-disable-next-line
  }, []);

  const handleRegistration: SubmitHandler<InputsFinalize> = async (data) => {
    if (invoiceType === "recipientAndPurchaserInvoice") {
      onSaveReservation({ ...data, createInvoice: true });
    } else {
      onPayTransaction({ ...data, createInvoice: invoiceType !== "noInvoice" });
    }

    setEmail(data.email);
    pixelAddBasket();
  };

  const [paymentType, setPaymentType] = useState<string>("online");
  const handleSetPayment = (type: string) => {
    setPaymentType(type);
  };

  const pixelAddBasket = () => {
    if (
      facilityIds === "273" ||
      facilityIds === "1224" ||
      facilityIds === "1200" ||
      facilityIds === "1204" ||
      facilityIds === "1227" ||
      facilityIds === "1214" ||
      facilityIds === "1240"
    ) {
      ReactPixel.fbq("track", "basketValueBeforePayU", {
        value: total,
        currency: "PLN",
      });

      gaEvent(
        "...",
        "purchase",
        {
          value: total,
          currency: "PLN",
        },
        ""
      );
    }
  };

  return (
    <div>
      <form className="finalize-no-login flex-between" onSubmit={handleSubmit(handleRegistration)}>
        <div className="basket-box shadow border">
          <h3>{t("jestes_zalogowany")}</h3>
          <div className="form">
            <input type="text" value={userData.firstName} />
            <input type="text" value={userData.email} />
            <input type="text" value={userData.phone} />
          </div>

          <EAButton title={t("wyloguj_sie")} variant="text" />

          {saleConfiguration.invoiceActive && (
            <React.Fragment>
              <h3>{t("faktura")}</h3>

              <InvoiceButtons invoiceType={invoiceType} setInvoiceType={setInvoiceType} />
            </React.Fragment>
          )}
        </div>

        <div className="basket-box shadow border">
          {invoiceType !== "noInvoice" && (
            <div>
              {invoiceType === "recipientAndPurchaserInvoice" ? (
                <RecipientAndPurchaserForm register={register} errors={errors} />
              ) : (
                <>
                  {" "}
                  <h3>{t("dane_do_faktury")}</h3>
                  <div className={"inputs-customer-invoice"}>
                    {invoiceForm(register, invoiceType === "companyInvoice").map(
                      (item: FormElementModel, index: number) =>
                        item.name && <FormInput key={index} {...item} errors={errors} />
                    )}
                  </div>
                </>
              )}
            </div>
          )}

          {invoiceType === "noInvoice" && (
            <ConsentInputs errors={errors} control={control} setValue={setValue} email={email} title={t("zgody")} />
          )}
        </div>

        <div className="basket-box shadow border">
          {invoiceType !== "noInvoice" && (
            <ConsentInputs errors={errors} control={control} setValue={setValue} email={email} title={t("zgody")} />
          )}
          {paymentType === "online" ? (
            <>
              <BasketSummary total={total} />

              {alertPayment.length > 2 && <div className="alert alert-red">{alertPayment}</div>}

              {!loader ? (
                <>
                  {paymentUrl === "" ? (
                    <EAButton title={t("kupuje_z_obowiazkiem_zaplaty")} inputType="submit" fullWidth />
                  ) : (
                    <>
                      <EAButton
                        title={t("przejdz_do_platnosci")}
                        fullWidth
                        onClick={() => window.open(paymentUrl, "_blank", "noreferrer")}
                      />
                    </>
                  )}
                </>
              ) : (
                <LoadingSpinner />
              )}
              <Timer />
              <PaymentLogos />

              <EcardButton handleSetPayment={handleSetPayment} />
            </>
          ) : (
            <>
              <EcardSummary eCardPaymnet={eCardPaymnet} handleSetPayment={handleSetPayment} alert={alert} />
            </>
          )}
        </div>
      </form>
    </div>
  );
};

export default FinalizeWithLogin;
